var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177,
    height: 158,
    viewBox: "0 0 177 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19625",
    "data-name": "Rectangle 19625",
    width: 177,
    height: 158,
    transform: "translate(0.263 -0.083)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Network",
    transform: "translate(-0.263 0.083)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M141.549,41.537a27.508,27.508,0,0,1-7.226,17.439c-.891,1.016-1.271,1.081-1.951-.248-3.967-7.73-10.382-11.894-19.039-11.916-8.731-.022-15.211,4.15-19.193,11.953-.731,1.439-1.118,1.111-1.958.2A28.518,28.518,0,0,1,87.806,27.6a28.2,28.2,0,0,1,27.558-15.81c15,1.257,26.236,13.428,26.17,29.735Z",
    transform: "translate(-22.896 -3.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M49.905,186.529c-4.588-.153-8.943-.5-13.07-2.163-4.552-1.827-5.728-4.062-4.727-8.826a17.974,17.974,0,0,1,35.515,1.512c.424,3.295-.468,5.048-3.558,6.634-4.508,2.323-9.425,2.63-14.159,2.835Z",
    transform: "translate(-8.565 -43.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M117.592,186.534c-4.851-.161-9.206-.5-13.341-2.148-4.559-1.812-5.677-3.806-4.837-8.592a17.952,17.952,0,0,1,35.595,2.082,5.438,5.438,0,0,1-2.9,5.428,23.452,23.452,0,0,1-9.162,2.791c-1.921.263-3.872.321-5.348.431Z",
    transform: "translate(-26.718 -43.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M184.566,186.53c-4.559-.146-8.913-.5-13.041-2.155-4.6-1.841-5.7-3.916-4.742-8.8a17.952,17.952,0,0,1,35.412.9c.563,3.974-.431,5.859-4.1,7.54-4.347,2-9.016,2.331-13.538,2.513Z",
    transform: "translate(-44.85 -43.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M118.018,82.788a29.162,29.162,0,0,1-15.737-4.574c-.986-.628-1.279-1.169-.811-2.331a17.489,17.489,0,0,1,32.395.058,1.531,1.531,0,0,1-.738,2.206,28.5,28.5,0,0,1-15.1,4.639Z",
    transform: "translate(-27.282 -17.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M176.125,105.691v-6.2c0-1.41.548-2.469,2.068-2.426,1.4.037,1.914,1.037,1.907,2.389-.029,3.646-.022,7.291,0,10.944a2.094,2.094,0,0,1-2.331,2.389c-3.711.029-7.416.015-11.127.007-1.344,0-2.279-.577-2.25-2.031.029-1.374.964-1.856,2.214-1.856h6.166c-.095-.994-.753-1.322-1.2-1.768-6.729-6.765-13.45-13.545-20.252-20.238-1.074-1.059-.964-1.644.066-2.542.928-.8,1.454-1.71,2.82-.3,6.656,6.838,13.443,13.553,20.194,20.3a3.866,3.866,0,0,0,1.732,1.337Z",
    transform: "translate(-40.566 -22.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M63.713,108.877c1.973,0,3.887.022,5.8-.007,1.366-.022,2.564.314,2.6,1.87.044,1.658-1.169,2.053-2.623,2.046-3.4-.029-6.817,0-10.221-.015-2.279-.015-2.849-.57-2.857-2.776-.015-3.47.015-6.933-.015-10.4-.007-1.388.409-2.521,1.943-2.55s2,1.1,1.987,2.491c-.015,1.995,0,3.989,0,6.027.95-.029,1.257-.709,1.688-1.14,6.8-6.787,13.633-13.553,20.333-20.442,1.315-1.352,1.826-.5,2.681.3.891.826,1.41,1.366.2,2.55C78.42,93.52,71.706,100.307,64.97,107.08A3,3,0,0,0,63.713,108.877Z",
    transform: "translate(-15.199 -22.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M53.365,148.343a8.322,8.322,0,1,1-.051-16.643,8.325,8.325,0,0,1,.044,16.65Z",
    transform: "translate(-12.127 -35.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M188.02,148.343a8.322,8.322,0,1,1-.037-16.643,8.418,8.418,0,0,1,8.292,8.227A8.333,8.333,0,0,1,188.02,148.343Z",
    transform: "translate(-48.399 -35.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M112.39,139.938a8.271,8.271,0,1,1,8.256,8.4A8.283,8.283,0,0,1,112.39,139.938Z",
    transform: "translate(-30.282 -35.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M117.911,108.334V96.74c0-2.024,1.6-3.025,3.5-2.214.723.314.453.928.453,1.417.037,4.077.037,8.153.051,12.223a2.029,2.029,0,0,0,.117.358c1.4-.818,2.279-2.141,3.419-3.149.548-.482,1.016-1.059,1.593-1.5a1.794,1.794,0,0,1,2.5.095,1.744,1.744,0,0,1,.183,2.616q-4.23,4.416-8.621,8.672a1.777,1.777,0,0,1-2.637-.153q-4.153-4.11-8.241-8.278a1.809,1.809,0,0,1-.095-2.762,1.877,1.877,0,0,1,2.908.066c1.505,1.447,2.959,2.944,4.435,4.413l.438-.219Z",
    transform: "translate(-29.513 -25.377)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M130.535,39.018A10.883,10.883,0,1,1,119.722,28.03,10.9,10.9,0,0,1,130.535,39.018Z",
    transform: "translate(-29.307 -7.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M121.156,47.383a4.91,4.91,0,1,1,.007.007Z",
    transform: "translate(-30.748 -8.978)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/Network.16600cf59eb7d458a79478301473861f.svg";
export { ForwardRef as ReactComponent };